import { creditFormGenderToDadata } from 'shared/lib';
import type { TCustomerData } from 'shared/types/TCustomerService';
import type { TDadataFullNameSuggest } from 'shared/types/TDaData';

export const convertFullNameField = (
  value: unknown,
  gender?: TCustomerData['gender'],
): Nullable<Dictionaries.TSelectValue<string, TDadataFullNameSuggest['data'] | null>> => {
  if (!value || typeof value !== 'string') {
    return null;
  }

  const [surname, name, patronymic = null] = String(value).trim().split(/\s+/);

  const fullName = [surname, name, patronymic].filter(Boolean).join(' ').trim();

  return {
    value: fullName,
    label: fullName,
    data: {
      surname,
      name,
      patronymic,
      qc: '0',
      source: null,
      gender: creditFormGenderToDadata(gender || 'Unknown'),
    },
  };
};
